import React from 'react';
import { connect } from 'react-redux';
import NewAgreementButton from './NewAgreementButton';
import './AgreementLanding.css';

// Keep old bookmarks intentional, without mounting any listing components.
export const RETIRED_MARKETPLACE_PAGES = ['postings', 'posting', 'newposting', 'userpostings'];

export function isRetiredMarketplacePath(pathname = '') {
  const page = pathname.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
  return RETIRED_MARKETPLACE_PAGES.includes(page);
}

function MarketplaceRetired({ auth }) {
  // /contracts without a signed-in user renders a "user doesn't exist" card,
  // so only offer that link once the visitor is logged in.
  const loggedIn = auth.status === 'loggedin';

  return (
    <main className="agreementRetired agreementHomeInner">
      <div className="agreementEyebrow">Atstake agreements</div>
      <h1>The marketplace has been retired.</h1>
      <p>Postings are no longer available here. Atstake is focused on creating
        agreements directly with someone you know.</p>
      <p>This change does not delete existing agreements or their history.</p>
      <div className="agreementHomeActions">
        <NewAgreementButton />
        {loggedIn && <a className="agreementTextLink" href="/contracts">View your contracts</a>}
        <a className="agreementTextLink" href="/">Return home</a>
      </div>
    </main>
  );
}

export default connect(state => ({ auth: state.auth }))(MarketplaceRetired);
